// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cc{display:flex;justify-content:center;flex-direction:column;align-items:center}.el-radio__inner{height:1.25rem!important;width:1.25rem!important;line-height:1.25rem!important;text-align:center!important}.el-radio__label{font-size:1rem;padding-left:1.125rem;color:#233333}", ""]);
// Exports
module.exports = exports;
